export const buildTimeFromServer = "2026-04-23 12:39:04";
